import { ConfirmModal } from './ConfirmModal';
import type { useUnsavedChangesPrompt } from '../../hooks/useUnsavedChangesWarning';

type UnsavedPrompt = ReturnType<typeof useUnsavedChangesPrompt>;

export function UnsavedChangesModal({
  prompt,
  message,
}: {
  prompt: UnsavedPrompt;
  message?: string;
}) {
  return (
    <ConfirmModal
      open={prompt.open}
      title={prompt.title}
      confirmLabel="Leave Without Saving"
      cancelLabel="Stay"
      confirmVariant="danger"
      onCancel={prompt.cancel}
      onConfirm={prompt.confirm}
    >
      <p style={{ margin: 0 }}>{message ?? prompt.message}</p>
    </ConfirmModal>
  );
}
